export const SUBSCRIPTION_MAX_PLUS_PRODUCTS_LIMIT = 5
export const SUBSCRIPTION_MAX_FREE_PRODUCTS_LIMIT = 1
